import { colSpanClassMap } from './constants';
import MainSliderContent from './MainSliderContent';
import ResponsiveSliderImage from './ResponsiveSliderImage';
import type { MainSliderItem } from './types';
import { cn, getButtons } from './utils';

interface BlocksSlideProps {
  slide: MainSliderItem;
}

const BlocksSlide = ({ slide }: BlocksSlideProps) => {
  const parts = slide.parts ?? [];

  return (
    <div
      className={cn(
        'bg-surface-marketing-warm h-full overflow-hidden rounded-2xl shadow-sm',
        slide.slideClassName,
      )}
    >
      <div
        className={cn(
          'laptop:grid-cols-12 grid h-full grid-cols-1 gap-0',
          slide.innerClassName,
        )}
      >
        {parts.map((part) => {
          const span = part.span ?? 6;

          if (part.type === 'image') {
            return (
              <div
                key={part.id}
                className={cn(
                  'relative h-full min-h-0 overflow-hidden',
                  colSpanClassMap[span],
                  part.className,
                )}
              >
                <ResponsiveSliderImage
                  imagePath={part.imagePath}
                  mobileImagePath={part.mobileImagePath}
                  imageAlt={part.imageAlt}
                  className="absolute inset-0 h-full w-full"
                  imageClassName={cn('object-cover', part.imageClassName)}
                  priority
                />
              </div>
            );
          }

          const buttons = getButtons(part.buttons, part.button);

          return (
            <div
              key={part.id}
              className={cn(
                'tablet:p-12 flex h-full min-h-0 flex-col justify-center p-8',
                colSpanClassMap[span],
                part.className,
              )}
            >
              <MainSliderContent
                content={part.content}
                buttons={buttons}
                textPosition={part.textPosition ?? 'center'}
                richTextStyles={part.richTextStyles}
                buttonClassName={slide.buttonClassName}
                buttonsClassName={slide.buttonsClassName}
                buttonAlignment={part.buttonAlignment} // Add this
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BlocksSlide;
